import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export const useAuth = () => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem('token');
    const userType = localStorage.getItem('userType');
    const userId = localStorage.getItem('userId');
    const userName = localStorage.getItem('userName');

    if (token && userType) {
      setUser({ token, userType, userId, userName });
    }
    setLoading(false);
  }, []);

  const login = (token, userType, userId, userName = null) => {
    localStorage.setItem('token', token);
    localStorage.setItem('userType', userType);
    localStorage.setItem('userId', userId);
    if (userName) {
      localStorage.setItem('userName', userName);
    }
    setUser({ token, userType, userId, userName });
  };

  const logout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('userType');
    localStorage.removeItem('userId');
    localStorage.removeItem('userName');
    setUser(null);
    navigate('/');
  };

  return { user, loading, login, logout };
};
